import React from 'react';
import { useParams } from 'react-router-dom';
import CreateWorkOrder from './CreateWorkOrder';

const EditWorkOrder = () => {
  const { id } = useParams();

  return <CreateWorkOrder editMode={true} workOrderId={id} />;
};

export default EditWorkOrder;

